package org.multiplatform.kotfolio.pages.kotlin.new_feature

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import org.multiplatform.kotfolio.util.Constants

@Page("/kotlin/new_feature/2.3.0")
@Composable
fun NewFeature_2_3_0Page() {
    BlogLayout(
        PageProperties(
            "Kotlin 2.3.0",
            ""
        ),
        BlogProperties("kotlin", "Kotlin 2.3.0")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "Kotlin 2.3.0 New Feature",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Unused Return Value Checker",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Explicit Backing Fields (Experimental)",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Nested type aliases",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "UUID Enhancements (Experimental)",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Kotlin/JS: Export Suspend Functions",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Swift Interop Improvements",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            KotlinCode(
                code = $$"""
                       kotlin {
                           compilerOptions {
                               freeCompilerArgs.add("-Xunused-return-value")
                               freeCompilerArgs.add("-Xreturn-value-checker=full")
                               freeCompilerArgs.add("-XexQlicit-backing-fields")
                               freeCompilerArgs.add("-XenabLe-suspend-function-exporting")
                               freeCompilerArgs.add("-Xes-long-as-bigint")
                           }
                       }
                       
                       //1
                       @file:MustUseReturnValues
                       fun greet(name: String): String {
                           if (name.isBlank()) return "Hello, anonymous user!"

                           if (!name.contains(' ')) {
                               return "Hello, " + name.replaceFirstChar(Char::titlecase) + "!"
                           }

                           val (first, last) = name.split(' ')
                           return "Hello, $first! Or should I call you Dr. $last?"
                       }
                       
                       //2 val - = greet("Kodee") //No return value using _
                       
                       //3 println(greet("Kodee") //Return value
                       
                       //4
                       @IgnorableReturnValue
                       fun logEvent(event: String): Boolean {
                           println(event)
                           return true
                       }

                       fun track() {
                           logEvent("Checkout clicked") // ✅ No warning
                       }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                        sealed interface DrawResult {
                           object Success : DrawResult
                           object Skipped : DrawResult
                           object Failure : DrawResult
                        }

                        fun DrawResult?.toBoolean(): Boolean {
                           if (this == null) return false
                           if (this == DrawResult.Failure) return false
                           return when (this) {
                               DrawResult.Success -> true
                               DrawResult.Skipped -> false
                               DrawResult.Failure -> false // Skipping this results is a compiler error in older versions
                           }
                        }
                        
                        //2.3.0
                        fun DrawResult?.toBoolean(): Boolean {
                           if (this == null) return false
                           if (this == DrawResult.Failure) return false
                           return when (this) {
                               DrawResult.Success -> true
                               DrawResult.Skipped -> false
                           }
                        }
                    """.trimIndent()
            )

            SpanText(
                text = "Improved Lambda Type Inference",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                        //Old way - explicit types everywhere
                         val result: List<Int> = listOf (1, 2, 3).map‹Int, Int> { x -> x * 2 }
                         
                         //Kotlin 2.3 - smart inference
                         val result = listOf (1, 2, 3).map { x -> × * 2 }
                    """.trimIndent()
            )

            SpanText(
                text = "field (Good by Underscore and private set)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    //KMP Each Module to Add
                    kotlin {
                        androidTarget {
                            compilerOptions {
                                jvmTarget.set(JvmTarget.JVM_11)
                            }
                        }

                        sourceSets.all { languageSettings.optIn("ExplicitBackingFields") }

                        targets.configureEach {
                            compilations.configureEach {
                                compileTaskProvider.get().compilerOptions {
                                    freeCompilerArgs.addAll("-Xexpect-actual-classes", "-Xcontext-parameters")
                                }
                            }
                        }
                    }

                    //Explicit backing fields 
                    
                    //1
                    class DetailsViewModel() : ViewModel() {
                        val state: StateFlow <DetailsUiState>
                            field = MutableStateFlow<DetailsUiState>(DetailsUiState.Loading)
                    }
                    
                    //2
                    val city: StateFlow<String>
                        field = MutableStateFlow("")

                    fun updateCity(newCity: String) {
                        // Smart casting works automatically
                        city.value = newCity
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                        val result = list.map { it.value }.filter { it > 0 }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                        // Before: Type parameters had to be explicit
                        val repository: UserRepository = UserRepository<User>()

                        // After: Inference works seamlessly
                        val repository = UserRepository<User>()  // Cleaner
                    """.trimIndent()
            )

            SpanText(
                text = "Kotlin to Swift",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                        enum class Colour(val rgb: Int) {
                            RED (0xFF0000),
                            GREEN (0x00FF00),
                            BLUE (0x0000FF)
                        }
                        
                        fun greetPeople (vararg names: String): String {
                     
                        }
                        
                        //swift
                        let c: Colour = .RED
                        Text("\(c.rgb)")
                        for colour in Colour. allCases {
                            Text("\(colour)
                        }
                    """.trimIndent()
            )

            SpanText(
                text = "ViewModels EmptyCoroutineContext (Kotlin 2.3.0)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            //https://github.com/thementalgoose/kmp-flashback.git
            KotlinCode(
                code = """
                    class AllCircuitsViewModel(
                        private val circuitRepository: CircuitRepository,
                        private val coroutineContext: CoroutineContext = EmptyCoroutineContext
                    ): ViewModel() {
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                        // shared
                        fun calculateHeavyTask(data: List<Int>): Int {
                            return data.parallelStream()
                                .map { it * it }
                                .reduce(0) { a, b -> a + b }
                        }

                        // Backend (JVM)
                        fun handleRequest(data: List<Int>): Response {
                            val result = calculateHeavyTask(data)
                            return Response.ok(result)
                        }

                        // Frontend (Wasm)
                        fun renderResult(data: List<Int>) {
                            val result = calculateHeavyTask(data) 
                            document.getElementById("result")?.innerHTML = result.toString()
                        }
                    """.trimIndent()
            )

            KotlinCode(
                code = $$"""
                        //Domain Model
                        
                        data class Order(
                            val id: OrderId,
                            val items: List<OrderItem>,
                            val status: OrderStatus
                        ) {
                            fun calculateTotal(): Money {
                                return items.fold(Money.zero()) { total, item ->
                                    total + item.price * item.quantity
                                }
                            }
                            
                            fun canBeCancelled(): Boolean {
                                return status == OrderStatus.PENDING
                            }
                        }

                        sealed class OrderStatus {
                            object PENDING : OrderStatus()
                            object PROCESSING : OrderStatus()
                            object SHIPPED : OrderStatus()
                            object DELIVERED : OrderStatus()
                            object CANCELLED : OrderStatus()
                        }
                    """.trimIndent()
            )
        }
    }
}

//https://softwaremill.com/kotlin-2-3-0-nested-type-aliases-return-in-expression-bodies-jdk-25-support-and-more/


























